import React from 'react'
import { useSelector } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import ListItem from 'srcReact/components/common2/ListItem'
// import Button from 'srcReact/components/common2/Button'

const SidebarMenu = ({ activeItem, setActiveItem, listItems, selectedWorkplace }) => {
  const { t } = useTranslation()

  const {
    common: { isDesktop }
  } = useSelector((state) => state)

  return (
    <div className={styles.sidebarMenuWrapper}>
      {listItems.map((l, idx) => (
        <ListItem
          key={idx}
          heading={l.heading}
          items={l.items}
          counts={l.counts}
          icons={l.icons}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          // className={idx === 0 ? styles.listItems : ''}
          className={styles.listItems}
          headerStyle={styles.headerStyle}
          showIcon={!isDesktop}
          layout={isDesktop ? 'list' : 'card'}
          color={selectedWorkplace?.color}
        />
      ))}
      {/* <Button
        customStyle={styles.deleteBtn}
        text={t('workplaceSettings.deleteWorkplace')}
        size='large'
      /> */}
    </div>
  )
}

export default SidebarMenu
